import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import BudgetDuringInspectionSectionGridItem from '@/orderDetails/BudgetDuringInspectionSection/BudgetDuringInspectionSectionGridItem';
import BudgetDuringInspectionSectionGridItemDetails from '@/orderDetails/BudgetDuringInspectionSection/BudgetDuringInspectionSectionGridItemDetails';
import BudgetDuringInspectionIcon from '@/svg-icons/BudgetDuringInspection';

const includeBudgetEnumTranslations = {
  simple: 'includeBudgetSimple',
  termination: 'includeBudgetTermination',
  no: 'includeBudgetNo',
};

const BudgetDuringInspectionSection = ({ data }) => {
  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <BudgetDuringInspectionIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0 align-middle" />
        <FormattedMessage id="budgetDuringInspection" />
      </div>

      <div className="flex flex-col text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)] gap-4">
        {data?.includeBudget && data.includeBudget in includeBudgetEnumTranslations && (
          <BudgetDuringInspectionSectionGridItem
            dataCy="include-budget"
            labelId="includeBudget"
            valueId={includeBudgetEnumTranslations[data.includeBudget]}
          />
        )}

        {data?.includeBudget && data.includeBudget !== 'no' && (
          <>
            <BudgetDuringInspectionSectionGridItem
              dataCy="contract-negotiation"
              labelId="contractNegotiation"
              valueId={data?.contractNegotiation ? 'Yes' : 'No'}
            />
            {data?.contractNegotiationDetails && (
              <BudgetDuringInspectionSectionGridItemDetails
                dataCy="contract-negotiation-details"
                labelId="DETAILS"
                value={data?.contractNegotiationDetails}
              />
            )}

            <BudgetDuringInspectionSectionGridItem
              dataCy="relevant-dealings"
              labelId="relevantDealings"
              valueId={data?.relevantDealings ? 'Yes' : 'No'}
            />
            {data?.relevantDealingsDetails && (
              <BudgetDuringInspectionSectionGridItemDetails
                dataCy="relevant-dealings-details"
                labelId="DETAILS"
                value={data?.relevantDealingsDetails}
              />
            )}

            <BudgetDuringInspectionSectionGridItem
              dataCy="final-maintenance-fee"
              labelId="finalMaintenanceFee"
              valueId={data?.finalMaintenanceFee ? 'Yes' : 'No'}
            />
            {data?.finalMaintenanceFeeDetails && (
              <BudgetDuringInspectionSectionGridItemDetails
                dataCy="final-maintenance-fee-details"
                labelId="DETAILS"
                value={data?.finalMaintenanceFeeDetails}
              />
            )}

            <BudgetDuringInspectionSectionGridItem
              dataCy="authorized-final-settlement"
              labelId="authorizedFinalSettlement"
              valueId={data?.authorizedFinalSettlement ? 'Yes' : 'No'}
            />
          </>
        )}
      </div>
    </div>
  );
};

BudgetDuringInspectionSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default BudgetDuringInspectionSection;
